import {AssertionUtils} from '@vdw/angular-component-library';
import {RestZonePosition} from '../rest-zone/rest-zone-position.enum';

export class RestZoneSettings {
  private _restPosition: RestZonePosition;
  private _userDefinedRestPosition?: RestZonePosition;
  private _maxDentsRestToDivideOverFree: number;

  public constructor(restPosition: RestZonePosition, userDefinedRestPosition: RestZonePosition | null, maxDentsRestToDivideOverFree: number) {
    this._restPosition = restPosition;
    this._userDefinedRestPosition = userDefinedRestPosition;
    this._maxDentsRestToDivideOverFree = maxDentsRestToDivideOverFree;
  }

  public get restPosition(): RestZonePosition {
    return this._restPosition;
  }

  public set restPosition(value: RestZonePosition) {
    this._restPosition = value;
  }

  public get userDefinedRestPosition(): RestZonePosition | null {
    return this._userDefinedRestPosition;
  }

  public set userDefinedRestPosition(value: RestZonePosition | null) {
    this._userDefinedRestPosition = value;
  }

  public get maxDentsRestToDivideOverFree(): number {
    return this._maxDentsRestToDivideOverFree;
  }

  public set maxDentsRestToDivideOverFree(value: number) {
    this._maxDentsRestToDivideOverFree = value;
  }

  public toJSON(): JSON {
    return {
      restPosition: RestZonePosition[this._restPosition],
      userDefinedRestPosition: AssertionUtils.isNullOrUndefined(this._userDefinedRestPosition) ? null : RestZonePosition[this._userDefinedRestPosition],
      maxDentsRestToDivideOverFree: this._maxDentsRestToDivideOverFree
    } as any as JSON;
  }

  public static fromJSON(json: any): RestZoneSettings {
    return new RestZoneSettings(
      RestZonePosition[json.restPosition as string],
      AssertionUtils.isNullOrUndefined(json.userDefinedRestPosition) ? null : RestZonePosition[json.userDefinedRestPosition as string],
      json.maxDentsRestToDivideOverFree
    );
  }
}
